import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { logVersionInfo, displayVersionWatermark } from './version.js'

// Initialize version logging
logVersionInfo();
displayVersionWatermark();

// Add debugging to distinguish between our WebSocket connections and Vite HMR
if (import.meta.hot) {
  console.log('Development mode: Vite HMR WebSocket may show connection errors to localhost:3000')
  console.log('Application WebSocket connections should go to: https://tevv-pipeline-api.com')
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
